export default function FAQSection() {
  const faqs = [
    {
      question: 'What areas do you serve in Pennsylvania?',
      answer: 'We proudly serve Allentown, Bethlehem, Easton, Nazareth, Forks Township, Wind Gap, Pen Argyl, Bangor, Bath, Whitehall, Northampton, Hellertown, Tatamy PA, and Phillipsburg NJ. Contact us if your area is not listed - we may still be able to help!'
    },
    {
      question: 'How far in advance should I book my event entertainment rental?',
      answer: 'We recommend booking 2-4 weeks in advance, especially for weekends and peak seasons. However, we offer same-day service when available for last-minute events. Call us at (610) 253-2835 to check availability.'
    },
    {
      question: 'Are your bounce houses and equipment safe and clean?',
      answer: 'Absolutely! Safety is our top priority. All equipment is professionally cleaned and sanitized before and after each rental. We inspect every item for safety and maintain all equipment to the highest standards. We are fully licensed and insured.'
    },
    {
      question: 'What is included in the rental price?',
      answer: 'Our rental prices include free delivery within our service area, professional setup, safety instructions, and pickup after your event. There are no hidden fees - we provide transparent, upfront pricing.'
    },
    {
      question: 'What types of events do you cater to?',
      answer: 'We serve all types of events including birthday parties, corporate events, school functions, church festivals, community gatherings, graduation parties, family reunions, and more. No event is too big or too small!'
    },
    {
      question: 'What happens if it rains on my event day?',
      answer: 'Weather policies vary by rental type. Many of our inflatables can be used in light rain, but we prioritize safety. Contact us to discuss weather concerns and rescheduling options. We work with you to ensure your event is successful.'
    },
    {
      question: 'Do you require a deposit?',
      answer: 'Yes, we require a deposit to secure your reservation. The deposit amount varies based on your rental package. The remaining balance is due on the day of your event. We accept multiple payment methods for your convenience.'
    },
    {
      question: 'Can I add more items to my rental after booking?',
      answer: 'Yes! You can add additional items to your rental based on availability. Contact us as soon as possible to discuss adding more entertainment options to make your event even more memorable.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Got questions? We've got answers. Find everything you need to know about our event entertainment rentals.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details 
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl overflow-hidden hover:border-red-200 transition-all"
            >
              <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                <h4 className="text-base font-bold text-gray-900 pr-4">
                  {faq.question}
                </h4>
                <i className="ri-arrow-down-s-line text-2xl text-red-600 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-6">
                <p className="text-sm text-gray-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-base text-gray-600 mb-6">
            Still have questions? We're here to help!
          </p>
          <a 
            href="tel:6102532835" 
            className="inline-block bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (610) 253-2835
          </a>
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
}